module.exports = __webpack_public_path__ + "img/partner_51.9be96d52.png";